import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FINANCIAL_PERFORMANCE_OPTION_NAMES } from '../FinancialPerformance/utils/form';

export const useGetFinancialPerfomanceOptions = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    return [
      {
        label: t('financialPlan.financialPerformance.investment.title'),
        value: FINANCIAL_PERFORMANCE_OPTION_NAMES.INVESTMENT,
      },
      {
        label: t('financialPlan.financialPerformance.profitability.title'),
        value: FINANCIAL_PERFORMANCE_OPTION_NAMES.PROFITABILITY,
      },
      {
        label: t('financialPlan.financialPerformance.liquidity.title'),
        value: FINANCIAL_PERFORMANCE_OPTION_NAMES.LIQUIDITY,
      },
      {
        label: t('financialPlan.financialPerformance.efficiency.title'),
        value: FINANCIAL_PERFORMANCE_OPTION_NAMES.EFFICIENCY,
      },
      {
        label: t('financialPlan.financialPerformance.solvency.title'),
        value: FINANCIAL_PERFORMANCE_OPTION_NAMES.SOLVENCY,
      },
    ];
  }, [t, i18n]);
};
